module.exports = __webpack_public_path__ + "static/media/mercadopago-logo.69753954.png";